import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  ScrollView,
  FlatList,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import moment from "moment";
const { width, height } = Dimensions.get("window");

export default function payment({ navigation, route }) {
  const user = route?.params;
  const token = useRecoilValue(tokenState);
  const [data, setdata] = useState([]);

  useEffect(() => {
    getHistorymok();
  }, []);

  async function getHistorymok() {
    const response = await apiservice({
      path: "/event/getallmockpayment/" + user.id,
      token: token.accessToken,
    });
    if (response.status == 200) {
      setdata(
        response.data.data.filter((i) => {
          return i.Type == "EVENT";
        })
      );
    }
  }

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              USER{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>Payment history</Text>
              </Text>
            </Text>
            <View style={{ flexDirection: "row" }}>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate("ProflieUser", { item: route.params })
                }
                style={[styles.touchadd, { backgroundColor: "#fff" }]}
              >
                <Text style={styles.textadd}>PROFILE</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.touchadd,
                  { backgroundColor: "#FCC81D" },
                  { marginLeft: 10 },
                ]}
              >
                <Text style={styles.textadd}>PAYMENT HISTORY</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.view}>
            <View style={styles.head}>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={[styles.texthead, { alignSelf: "center" }]}>
                  ออเดอร์
                </Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.2 }]}>
                <Text style={styles.texthead}>รายการ</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>วันที่ชำระเงิน</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>เวลา</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.128 }]}>
                <Text style={styles.texthead}>ชำระเงินผ่านระบบ</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>ราคา</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>สถานะ</Text>
              </View>
            </View>
            <FlatList
              data={data}
              scrollEnabled={false}
              renderItem={({ index, item }) => {
                return (
                  <View>
                    <View
                      style={[styles.viewmain, { backgroundColor: "#fff" }]}
                    >
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>#{item.id + 10000}</Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.2 }]}>
                        <Text style={styles.textdate}>{item.event_name}</Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>
                          {moment(item.createdAt).format("DD-MMM-YYYY")}
                        </Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>
                          {moment(item.createdAt).format("HH:mm")}
                        </Text>
                      </View>
                      <View
                        style={[styles.viewdetail, { width: width * 0.128 }]}
                      >
                        <Text style={[styles.textdate]}>{"creditcard"}</Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>
                          {parseInt(item?.pay_status) +
                            parseInt(item?.isBIBVIP ? 99 : 0)}
                        </Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={[styles.textdate, { color: "#2DCE98" }]}>
                          {"ชำระแล้ว"}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              }}
            />
            {/* <View style={styles.viewatc}>
              <TouchableOpacity style={styles.touchatc}>
                <FontAwesome
                  name="angle-left"
                  size={15}
                  color="#7764E4"
                  style={{ alignSelf: "center" }}
                />
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.touchatc, { backgroundColor: "#FCC81D" }]}
              >
                <Text style={styles.textatc}>1</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.touchatc}>
                <Text style={styles.textatc}>2</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.touchatc}>
                <Text style={styles.textatc}>3</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.touchatc}>
                <Text style={styles.textatc}>4</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.touchatc}>
                <FontAwesome
                  name="angle-right"
                  size={15}
                  color="#7764E4"
                  style={{ alignSelf: "center" }}
                />
              </TouchableOpacity>
            </View> */}
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 180,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  head: {
    width: width * 0.828,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    paddingLeft: 10,
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
  },
  viewdetail: {
    flexDirection: "row",
  },
  img: {
    width: 39,
    height: 39,
    marginTop: 5,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: 15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: 15,
  },
  viewmain: {
    flexDirection: "row",
    width: width * 0.828,
    height: 50,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  view: {
    width: width * 0.83,
    height: 500,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 20,
  },
});
